import styled from 'styled-components';
import { spacing } from '../../styles/theme';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-grow: 1;
`;

export const FormContainer = styled.section`
  width: 40%;
  padding: ${spacing('10')} 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
